import React, { useState, useEffect, useMemo } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./Dashboard.css";
import { getEmotionHomePageSummaryService, getCurrentUserRoleService } from "services/api-service";

import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import SearchIcon from "@mui/icons-material/Search";
import { useLocation } from "react-router-dom";

import routes from "routes.js";
import MemberAttendanceBoard from "components/member-dashboard/memberboard";
import Staffboard from "components/staff-dashboard/staffboard";
import PeopleCountingBoard from "components/people-counting/PeopleCountingBoard"; 
import ilogo from "assets/img/Clogo1.png";

function Dashboard() {
  const theme = useTheme();
  const md_matches = useMediaQuery(theme.breakpoints.down("md"));
  const today = new Date();
  const formattedToday = today.toISOString().split("T")[0];

  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    getCurrentUserRoleService()
      .then(res => setUserRole(res.data.role_type))
      .catch(err => console.error("Error fetching user role:", err));
  }, []);

  // ✅ Default View set to "staff"
  const [activeView, setActiveView] = useState("staff"); 

  const [selectedChartData, setSelectedChartData] = useState("");
  const [emotionChart, setEmotionChart] = useState([]);

  const [selectedDate, setSelectedDate] = useState(
    localStorage.getItem("selectData") || formattedToday
  );

  useEffect(() => {
    localStorage.setItem("selectedDatesw", selectedDate);
    localStorage.setItem("seDate", selectedDate);
  }, [selectedDate]);

  const [homePageSummary, setHomePageSummary] = useState(() => {
    const storedData = localStorage.getItem("homePageSummary");
    return storedData ? JSON.parse(storedData) : [];
  });

  const fetchDataByDate = async () => {
    if (!selectedDate) {
      toast.error("Please select a valid date.");
      return;
    }

    try {
      const response = await getEmotionHomePageSummaryService({
        date: selectedDate,
      });
      setEmotionChart([]);
      setHomePageSummary(response.data);
    } catch (error) {
      toast.error("Error: Failed to fetch data for the selected date.");
      console.error("Error fetching data by date:", error);
    }
  };

  const handleStartDateChange = (e) => {
    setSelectedDate(e.target.value);
    localStorage.setItem("selectedDatett", e.target.value);
  };

  useEffect(() => {
    if (selectedDate) {
      fetchDataByDate();
    }
  }, [selectedDate]);

  useEffect(() => {
    if (selectedChartData) {
      let id = selectedChartData?.split(" ");
      const filter = homePageSummary.filter((item) => {
        return item.session_id == id[1];
      });
      setEmotionChart([filter[0]]);
    }
  }, [selectedChartData, homePageSummary]);

  return (
    <>
      <div
        className="dashboard-headers"
        style={{
          marginTop: "0.1%",
          borderTop: "none",
          height: "auto",
          padding: md_matches ? "8px 12px" : "8px 20px",
        }}
      >
        <div
          className="dashboard-header-contents"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: md_matches ? "wrap" : "nowrap",
            gap: md_matches ? "10px" : "15px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: md_matches ? "10px" : "12px" }}>
            <img
              src={ilogo}
              alt="PRO_MINI"
              style={{
                height: md_matches ? "35px" : "40px",
                width: "auto",
                objectFit: "contain",
              }}
            />
            <span
              style={{
                fontSize: md_matches ? "14px" : "18px",
                fontWeight: "900",
                color: "#000",
              }}
            >
              CamsecAI_PRO_MINI
            </span>
          </div>

          <div
            className="dashboard-controls"
            style={{
              display: "flex",
              alignItems: "center",
              gap: md_matches ? "6px" : "15px",
              order: md_matches ? "3" : "unset",
              width: md_matches ? "100%" : "auto",
            }}
          >
            {/* ✅ 3-Way Toggle Button */}
            {userRole === "IT_ADMIN" && (
              <div style={{
                display: "flex",
                background: md_matches ? "#f3f4f6" : "#1e3a5f",
                borderRadius: "8px",
                padding: "4px",
                gap: "4px"
              }}>
                <button
                  type="button"
                  onClick={() => setActiveView("staff")}
                  style={{
                    background: activeView === "staff" ? (md_matches ? "#fff" : "#2563eb") : "transparent",
                    color: activeView === "staff" ? (md_matches ? "#000" : "#fff") : (md_matches ? "#666" : "#cbd5e1"),
                    border: "none", borderRadius: "6px", fontWeight: "700", padding: "6px 12px",
                    fontSize: md_matches ? "11px" : "13px", cursor: "pointer", transition: "all 0.2s"
                  }}
                >
                  👥 Staff
                </button>
                <button
                  type="button"
                  onClick={() => setActiveView("member")}
                  style={{
                    background: activeView === "member" ? (md_matches ? "#fff" : "#2563eb") : "transparent",
                    color: activeView === "member" ? (md_matches ? "#000" : "#fff") : (md_matches ? "#666" : "#cbd5e1"),
                    border: "none", borderRadius: "6px", fontWeight: "700", padding: "6px 12px",
                    fontSize: md_matches ? "11px" : "13px", cursor: "pointer", transition: "all 0.2s"
                  }}
                >
                  🌟 Visitors
                </button>
                <button
                  type="button"
                  onClick={() => setActiveView("counting")}
                  style={{
                    background: activeView === "counting" ? (md_matches ? "#fff" : "#2563eb") : "transparent",
                    color: activeView === "counting" ? (md_matches ? "#000" : "#fff") : (md_matches ? "#666" : "#cbd5e1"),
                    border: "none", borderRadius: "6px", fontWeight: "700", padding: "6px 12px",
                    fontSize: md_matches ? "11px" : "13px", cursor: "pointer", transition: "all 0.2s"
                  }}
                >
                  🚶 Counting
                </button>
              </div>
            )}

            <span
              style={{
                color: "rgba(0, 0, 0, 0.6)",
                fontWeight: "600",
                fontSize: md_matches ? "11px" : "14px",
                whiteSpace: "nowrap",
              }}
            >
              📅
            </span>

            <input
              type="date"
              className="date-input"
              value={selectedDate}
              onChange={handleStartDateChange}
              aria-label="Select date"
              style={{
                height: md_matches ? "32px" : "38px",
                width: md_matches ? "90px" : "160px",
                padding: "6px 10px",
                fontSize: md_matches ? "12px" : "13px",
                borderRadius: "4px",
                border: "1px solid #ddd",
              }}
            />

            <div
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                color: "#000",
              }}
              onClick={fetchDataByDate}
            >
              <SearchIcon style={{ fontSize: md_matches ? "18px" : "24px" }} />
            </div>
          </div>
        </div>
      </div>

      <Container fluid>
        <Row>
          <Col md="12">
            {activeView === "member" && (
              <MemberAttendanceBoard selectedDate={selectedDate} />
            )}
            {activeView === "staff" && (
              <Staffboard />
            )}
            {activeView === "counting" && (
              <PeopleCountingBoard selectedDate={selectedDate} />
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Dashboard;
